import axios from "axios";
import config from "./config";

// axios config
axios.defaults.baseURL = config.api;
axios.defaults.withCredentials = true;
axios.defaults.headers.common["Authorization"] = `Basic ${localStorage.getItem("token")}`;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept-Language"] = localStorage.getItem("lng") || "en";
